import React from "react";
import { insertFonts } from "../../../helpers/fontHelper";

export const FontBasline = ({ fonts, template, modules }) => {
  return fonts || template || modules ? (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: insertFonts(fonts, null),
        }}
      />
      <style
        dangerouslySetInnerHTML={{
          __html: insertFonts(null, template),
        }}
      />
      <style
        dangerouslySetInnerHTML={{
          __html: insertFonts(null, modules),
        }}
      />
    </>
  ) : null;
};
